import { useContext, useEffect, useRef } from 'react';
import type { AppNotification } from '../../api/notifications-client';
import { NotificationsContext } from './notifications-context';

/**
 * Hear each notification frame as it arrives over the one socket (Lobbero
 * Stays plan S6: the guest cards refetch when a frame about a stay on screen
 * lands). A NO-OP outside NotificationsProvider — the stay guest's public pages
 * have none — so a component can use it anywhere.
 *
 * The listener is held in a ref: passing a new function every render never
 * re-subscribes.
 */
export const useNotificationFrames = (listener: (row: AppNotification) => void): void => {
  const ctx = useContext(NotificationsContext);
  const subscribe = ctx ? ctx.subscribe : null;
  const ref = useRef(listener);
  ref.current = listener;

  useEffect(() => {
    if (!subscribe) return undefined;

    return subscribe(row => ref.current(row));
  }, [subscribe]);
};
